import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"
import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import notNull from "../../util/notNull"
import IconResizer from "../../icon/IconResizer"
import CheckIcon from "../../icon/CheckIcon"
import XMarkIcon from "../../icon/XMarkIcon"
import {
    ConfirmLinkingSpecification,
    DeleteUserRelationSpecification,
    GetLinkingRequestsResponsePayload,
    GetLinkingRequestsSpecification,
    GetPatientsOfProfessionalSpecification,
    LinkingRequest
} from "pokal_api"
import { dispatchThunk } from "../../redux/thunk/thunkify"
import { nothing } from "../../util/void"
import {
    hidePatientSelectionViewRequests,
    increaseOnboardingStep,
    selectOnboardingIsRunningState,
    selectOnboardingStep
} from "../../redux/Onboarding"
import mockPatientRequests from "../../onboarding/mock/mockPatientRequests"
import OnboardingStep from "../../onboarding/OnboardingStep"
import { selectLinkingRequests } from "../../redux/ProfessionalDashboard"
import { useEffect, useState } from "react"

function LinkingRequestsList() {
    const dispatch = useAppDispatch()
    const step = useAppSelector(selectOnboardingStep)
    const running = useAppSelector(selectOnboardingIsRunningState)

    const [linkingRequests, setLinkingRequests] =
        useState<GetLinkingRequestsResponsePayload | null>(null)

    const fetchedLinkingRequests = useAppSelector(selectLinkingRequests)
    const mockLinkingRequests = mockPatientRequests()

    function onboardingFocus(): boolean {
        return (
            running &&
            step === OnboardingStep.SHOW_PATIENT_SELECTION_VIEW_REQUESTS
        )
    }

    useEffect(() => {
        if (onboardingFocus()) {
            setLinkingRequests(mockLinkingRequests)
        } else {
            setLinkingRequests(fetchedLinkingRequests)
        }
    }, [step, running, fetchedLinkingRequests])

    function accept(request: LinkingRequest) {
        if (onboardingFocus()) {
            setLinkingRequests([])
            dispatch(increaseOnboardingStep())
        } else {
            ConfirmLinkingSpecification.request({ request: request.id }).then(
                () => {
                    dispatchThunk(
                        dispatch,
                        GetLinkingRequestsSpecification,
                        nothing
                    )
                    dispatchThunk(
                        dispatch,
                        GetPatientsOfProfessionalSpecification,
                        nothing
                    )
                }
            )
        }
    }

    function decline(request: LinkingRequest) {
        DeleteUserRelationSpecification.request({
            user: request.patient
        }).then(() => {
            dispatchThunk(dispatch, GetLinkingRequestsSpecification, nothing)
        })
    }

    return (
        <Card
            width={"100%"}
            fill={true}
            blur={hidePatientSelectionViewRequests(running, step)}>
            <div className={"flex flex-col space-y-4"}>
                <SmallHeadingComponent>
                    Patient:innen-Anfragen
                </SmallHeadingComponent>
                {linkingRequests === null && (
                    <div className={"italic"}>
                        Verbindungsanfragen konnten nicht geladen werden.
                    </div>
                )}
                {notNull(linkingRequests) && linkingRequests.length === 0 && (
                    <div className={"italic"}>
                        Momentan sind keine offenen Anfragen vorhanden.
                    </div>
                )}
                {notNull(linkingRequests) && linkingRequests.length > 0 && (
                    <div>
                        {linkingRequests.map((l) => (
                            <div
                                key={l.id}
                                className={
                                    "p-3 border rounded my-2 flex items-center"
                                }>
                                <div>{l.name}</div>
                                <div className={"ml-auto flex space-x-2"}>
                                    <div
                                        onClick={() => accept(l)}
                                        className={
                                            "p-2 rounded-full cursor-pointer hover:bg-neutral-200"
                                        }>
                                        <IconResizer
                                            size={20}
                                            color={"text-green-600"}>
                                            <CheckIcon />
                                        </IconResizer>
                                    </div>
                                    <div
                                        onClick={() => decline(l)}
                                        className={
                                            "p-2 rounded-full cursor-pointer hover:bg-neutral-200"
                                        }>
                                        <IconResizer
                                            size={20}
                                            color={"text-rose-600"}>
                                            <XMarkIcon />
                                        </IconResizer>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Card>
    )
}

export default LinkingRequestsList
